/* eslint-disable consistent-return, default-case, no-param-reassign */
/*
 *
 * Register reducer
 *
 */

import produce from 'immer';

import {
  CHANGE_INPUT,
  CHANGE_INPUT_ERROR,
  CHANGE_STEP,
  REGISTER_GUIDED_STEP_FOUR,
  REGISTER_GUIDED_STEP_FOUR_FAILURE,
  REGISTER_GUIDED_STEP_FOUR_SUCCESS,
  REGISTER_GUIDED_STEP_FOUR_VALIDATION_FAILURE,
  REGISTER_GUIDED_STEP_THREE,
  REGISTER_GUIDED_STEP_THREE_FAILURE,
  REGISTER_GUIDED_STEP_THREE_SUCCESS,
  REGISTER_RESEND_CHANGE_EMAIL,
  REGISTER_RESEND_EMAIL,
  REGISTER_RESEND_EMAIL_FAILURE,
  REGISTER_RESEND_EMAIL_SUCCESS,
  REGISTER_RESEND_EMAIL_VALIDATION_FAILURE,
  REGISTER_STEP_ONE,
  REGISTER_STEP_ONE_FAILURE,
  REGISTER_STEP_ONE_SUCCESS,
  REGISTER_STEP_TWO,
  REGISTER_STEP_TWO_FAILURE,
  REGISTER_STEP_TWO_SUCCESS,
  REGISTER_STEP_TWO_VALIDATION_FAILURE,
  REGISTER_VERIFY,
  REGISTER_VERIFY_FAILURE,
  REGISTER_VERIFY_SUCCESS,
  RESET_INPUTS,
  RESET_INPUT_ERRORS,
  RESET_STATE,
  UPDATE_REGISTER_CURRENT_EMAIL,
  VERIFY_RECAPTCHA_FAILURE,
  VERIFY_RECAPTCHA_SUCCESS,
} from './constants';

export const initialState = {
  error: {
    bannerError: false,
    guidedStepFourError: false,
    registerConfirmation: false,
    registerResend: false,
    serviceError: false,
    ssoLoanError: false,
    stepOneError: false,
    stepTwoError: false,
    verify: false,
  },
  form: {
    account: {
      confirmEmail: '',
      confirmPassword: '',
      currEmail: '',
      email: '',
      isChangeEmail: false,
      password: '',
      username: '',
    },
    consent: {
      contactAcknowledgment: false,
      electronicAcknowledgment: false,
      privacyAcknowledgment: false,
      termsAcknowledgment: false,
    },
    guidedAccount: {
      confirmPassword: '',
      password: '',
      username: '',
    },
    initial: {
      isRecaptchaVerified: false,
      loanNumber: '',
      ssnTin: '',
      zipCode: '',
    },
  },
  formErrors: {
    account: {
      confirmEmail: '',
      confirmPassword: '',
      email: '',
      password: '',
      username: '',
    },
    guidedAccount: {
      confirmPassword: '',
      password: '',
      username: '',
    },
    initial: {
      loanNumber: '',
      ssnTin: '',
      zipCode: '',
    },
  },
  status: {
    guidedStepFour: 'idle',
    guidedStepThree: 'loading',
    registerResendEmail: 'idle',
    stepOne: 'idle',
    stepTwo: 'idle',
    verify: 'idle',
  },
  step: 1,
  token: null,
};

const registerReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_INPUT: {
      const { field, form, value } = payload;
      draft.form[form][field] = value;
      break;
    }
    case CHANGE_INPUT_ERROR: {
      const {
        field,
        form,
        value,
      } = payload;
      draft.formErrors[form][field] = value;
      break;
    }
    case CHANGE_STEP: {
      const { step } = payload;
      draft.step = step;
      break;
    }
    case REGISTER_GUIDED_STEP_FOUR: {
      draft.error = initialState.error;
      draft.status.guidedStepFour = 'loading';
      break;
    }
    case REGISTER_GUIDED_STEP_FOUR_FAILURE: {
      const { error } = payload;
      const { key, message } = error;
      draft.error[key] = message;
      draft.status.guidedStepFour = 'failed';
      break;
    }
    case REGISTER_GUIDED_STEP_FOUR_SUCCESS: {
      draft.status.guidedStepFour = 'succeeded';
      break;
    }
    case REGISTER_GUIDED_STEP_FOUR_VALIDATION_FAILURE: {
      const { ...inputErrors } = payload;
      Object.keys(inputErrors).forEach((key) => {
        draft.formErrors.guidedAccount[key] = inputErrors[key];
      });
      draft.status.guidedStepFour = initialState.status.guidedStepFour;
      break;
    }
    case REGISTER_GUIDED_STEP_THREE: {
      draft.error = initialState.error;
      draft.formErrors = initialState.formErrors;
      draft.status.guidedStepThree = 'loading';
      break;
    }
    case REGISTER_GUIDED_STEP_THREE_FAILURE: {
      const { error } = payload;
      const { key, message } = error;
      draft.error[key] = message;
      draft.status.guidedStepThree = 'failed';
      break;
    }
    case REGISTER_GUIDED_STEP_THREE_SUCCESS: {
      const { token } = payload;
      draft.status.guidedStepThree = 'succeeded';
      draft.token = token;
      break;
    }
    case REGISTER_RESEND_CHANGE_EMAIL:
      draft.form.account.isChangeEmail = true;
      draft.error.registerResend = false;
      break;
    case REGISTER_RESEND_EMAIL:
      draft.error.registerResend = false;
      draft.error.registerConfirmation = false;
      draft.status.registerResendEmail = 'loading';
      break;
    case REGISTER_RESEND_EMAIL_FAILURE: {
      const { error } = payload;
      draft.error.registerConfirmation = error;
      draft.status.registerResendEmail = 'failed';
      break;
    }
    case REGISTER_RESEND_EMAIL_SUCCESS: {
      draft.status.registerResendEmail = 'succeeded';
      break;
    }
    case REGISTER_RESEND_EMAIL_VALIDATION_FAILURE: {
      const { bannerError, ...inputErrors } = payload;
      draft.status.registerResendEmail = 'failed';
      Object.keys(inputErrors).forEach((key) => {
        draft.form.account[key].error = inputErrors[key];
      });
      if (bannerError.length === 0) {
        draft.error.registerResend = false;
      } else if (bannerError.length === 1) {
        draft.error.registerResend = bannerError[0]; // eslint-disable-line prefer-destructuring
      } else {
        draft.error.registerResend = bannerError;
      }
      break;
    }
    case REGISTER_STEP_ONE: {
      draft.error = initialState.error;
      draft.status.stepOne = 'loading';
      break;
    }
    case REGISTER_STEP_ONE_FAILURE: {
      const { error } = payload;
      const { key, message } = error;
      draft.error[key] = message;
      draft.status.stepOne = 'failed';
      break;
    }
    case REGISTER_STEP_ONE_SUCCESS: {
      const { token } = payload;
      draft.status.stepOne = 'succeeded';
      draft.token = token;
      break;
    }
    case REGISTER_STEP_TWO: {
      draft.error = initialState.error;
      draft.status.stepTwo = 'loading';
      break;
    }
    case REGISTER_STEP_TWO_FAILURE: {
      const { error } = payload;
      const { key, message } = error;
      draft.error[key] = message;
      draft.status.stepTwo = 'failed';
      break;
    }
    case REGISTER_STEP_TWO_VALIDATION_FAILURE: {
      const { ...inputErrors } = payload;
      Object.keys(inputErrors).forEach((key) => {
        draft.formErrors.account[key] = inputErrors[key];
      });
      draft.status.stepTwo = 'failed';
      break;
    }
    case REGISTER_STEP_TWO_SUCCESS: {
      draft.status.stepTwo = 'succeeded';
      break;
    }
    case REGISTER_VERIFY: {
      draft.error.verify = initialState.error.verify;
      draft.status.verify = 'loading';
      break;
    }
    case REGISTER_VERIFY_FAILURE: {
      const { error } = payload;
      draft.error.verify = error;
      draft.status.verify = 'failed';
      break;
    }
    case REGISTER_VERIFY_SUCCESS: {
      draft.status.verify = 'succeeded';
      break;
    }
    case RESET_INPUTS: {
      draft.form = initialState.form;
      break;
    }
    case RESET_INPUT_ERRORS: {
      const { field, form } = payload;
      draft.formErrors[form][field] = initialState.formErrors[form][field];
      break;
    }
    case RESET_STATE: {
      return initialState;
    }
    case UPDATE_REGISTER_CURRENT_EMAIL: {
      const { email } = payload;
      draft.form.account.currEmail = email;
      break;
    }
    case VERIFY_RECAPTCHA_FAILURE: {
      draft.form.initial.isRecaptchaVerified = false;
      break;
    }
    case VERIFY_RECAPTCHA_SUCCESS: {
      draft.form.initial.isRecaptchaVerified = true;
      break;
    }
  }
}, initialState);

export default registerReducer;
